export default {
  ROLE: {
    ADMIN: 'admin'
  }
}



// WEBPACK FOOTER //
// ./src/constants.js